// frontend/src/pages/PaymentSuccess.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { fetchCreditBalance } from "../store/slices/creditSlice";
import { useTranslation } from "react-i18next";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCreditBalance());
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);
    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
    >
      <Typography variant="h4" color="success.main" gutterBottom>
        {t("payment.success")}
      </Typography>
      <Typography gutterBottom>{t("payment.creditsAdded")}</Typography>
      <CircularProgress sx={{ mt: 2 }} />
      <Typography variant="body2" sx={{ mt: 2 }}>
        {t("payment.redirectingToDashboard")}
      </Typography>
    </Box>
  );
};

export default PaymentSuccess;
